// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Belt_List from "../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Js_string from "../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getUrlPathString(path_name) {
  var path = Js_string.split("?", path_name);
  var match = path.length;
  if (match !== 0) {
    return Caml_array.get(path, 0);
  } else {
    return path_name;
  }
}

function getRoutePathList(str) {
  var cleanStr = getUrlPathString(str);
  return Belt_Option.getWithDefault(Belt_List.tail($$Array.to_list(Js_string.split("/", cleanStr))), /* [] */0);
}

export {
  getUrlPathString ,
  getRoutePathList ,
}
/* No side effect */
